function _typeof(obj) {
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== 'undefined' && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base)
                return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _getPrototypeOf(object);
        if (object === null)
            break;
    }
    return object;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module image/imagetextalternative/ui/textalternativeformview
 */
import View from '@ckeditor/ckeditor5-ui/src/view';
import ViewCollection from '@ckeditor/ckeditor5-ui/src/viewcollection';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import LabeledInputView from '@ckeditor/ckeditor5-ui/src/labeledinput/labeledinputview';
import InputTextView from '@ckeditor/ckeditor5-ui/src/inputtext/inputtextview';
import submitHandler from '@ckeditor/ckeditor5-ui/src/bindings/submithandler';
import KeystrokeHandler from '@ckeditor/ckeditor5-utils/src/keystrokehandler';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import FocusCycler from '@ckeditor/ckeditor5-ui/src/focuscycler';
import checkIcon from '@ckeditor/ckeditor5-core/theme/icons/check.svg';
import cancelIcon from '@ckeditor/ckeditor5-core/theme/icons/cancel.svg';
import '../../../theme/textalternativeform.css';
/**
 * The TextAlternativeFormView class.
 *
 * @extends module:ui/view~View
 */
var TextAlternativeFormView = /*#__PURE__*/
function (_View) {
    _inherits(TextAlternativeFormView, _View);
    /**
   * @inheritDoc
   */
    function TextAlternativeFormView(locale) {
        var _this;
        _classCallCheck(this, TextAlternativeFormView);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(TextAlternativeFormView).call(this, locale));
        var t = _this.locale.t;
        /**
     * Tracks information about the DOM focus in the form.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */
        _this.focusTracker = new FocusTracker();
        /**
     * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler}
     */
        _this.keystrokes = new KeystrokeHandler();
        /**
     * A textarea with a label.
     *
     * @member {module:ui/labeledinput/labeledinputview~LabeledInputView} #labeledTextarea
     */
        _this.labeledInput = _this._createLabeledInputView();
        /**
     * A button used to submit the form.
     *
     * @member {module:ui/button/buttonview~ButtonView} #saveButtonView
     */
        _this.saveButtonView = _this._createButton(t('Save'), checkIcon, 'ck-button-save');
        _this.saveButtonView.type = 'submit';
        /**
     * A button used to cancel the form.
     *
     * @member {module:ui/button/buttonview~ButtonView} #cancelButtonView
     */
        _this.cancelButtonView = _this._createButton(t('Cancel'), cancelIcon, 'ck-button-cancel', 'cancel');
        /**
     * A collection of views which can be focused in the form.
     *
     * @readonly
     * @protected
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this._focusables = new ViewCollection();
        /**
     * Helps cycling over {@link #_focusables} in the form.
     *
     * @readonly
     * @protected
     * @member {module:ui/focuscycler~FocusCycler}
     */
        _this._focusCycler = new FocusCycler({
            focusables: _this._focusables,
            focusTracker: _this.focusTracker,
            keystrokeHandler: _this.keystrokes,
            actions: {
                // Navigate form fields backwards using the Shift + Tab keystroke.
                focusPrevious: 'shift + tab',
                // Navigate form fields forwards using the Tab key.
                focusNext: 'tab'
            }
        });
        _this.setTemplate({
            tag: 'form',
            attributes: {
                class: [
                    'ck',
                    'ck-text-alternative-form'
                ],
                // https://github.com/ckeditor/ckeditor5-image/issues/40
                tabindex: '-1'
            },
            children: [
                _this.labeledInput,
                _this.saveButtonView,
                _this.cancelButtonView
            ]
        });
        return _this;
    }
    /**
   * @inheritDoc
   */
    _createClass(TextAlternativeFormView, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                _get(_getPrototypeOf(TextAlternativeFormView.prototype), 'render', this).call(this);
                this.keystrokes.listenTo(this.element);
                submitHandler({ view: this });
                [
                    this.labeledInput,
                    this.saveButtonView,
                    this.cancelButtonView
                ].forEach(function (v) {
                    // Register the view as focusable.
                    _this2._focusables.add(v);
                    // Register the view in the focus tracker.
                    _this2.focusTracker.add(v.element);
                });
            }    /**
     * Creates the button view.
     *
     * @private
     * @param {String} label The button label
     * @param {String} icon The button's icon.
     * @param {String} className The additional button CSS class name.
     * @param {String} [eventName] The event name that the ButtonView#execute event will be delegated to.
     * @returns {module:ui/button/buttonview~ButtonView} The button view instance.
     */
        },
        {
            key: '_createButton',
            value: function _createButton(label, icon, className, eventName) {
                var button = new ButtonView(this.locale);
                button.set({
                    label: label,
                    icon: icon,
                    tooltip: true
                });
                button.extendTemplate({ attributes: { class: className } });
                if (eventName) {
                    button.delegate('execute').to(this, eventName);
                }
                return button;
            }    /**
     * Creates an input with a label.
     *
     * @private
     * @returns {module:ui/labeledinput/labeledinputview~LabeledInputView}
     */
        },
        {
            key: '_createLabeledInputView',
            value: function _createLabeledInputView() {
                var t = this.locale.t;
                var labeledInput = new LabeledInputView(this.locale, InputTextView);
                labeledInput.label = t('Text alternative');
                labeledInput.inputView.placeholder = t('Text alternative');
                return labeledInput;
            }
        }
    ]);
    return TextAlternativeFormView;
}(View);
export {
    TextAlternativeFormView as default
};